import styled from "styled-components";

export const Solucoes = styled.section`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 43px;
  gap: 40px;

  #description {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1300px;

    gap: 30px;

    #desc-one {
      span {
        font-weight: 700;
        font-size: 12px;
        line-height: 122%;
        text-transform: uppercase;
        color: var(--orange);
      }

      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 122%;
        color: var(--title);
      }

      img {
        width: 45%;
      }

      #olhada-desktop {
        display: none;
      }
    }

    #desc-two {
      display: flex;
      flex-direction: column;
      gap: 15px;

      #bold-desc-two {
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: var(--paragraph);
      }

      #paragraph-desc-two {
        font-weight: 400;
        font-size: 14px;
        line-height: 160%;
        color: var(--paragraph);
      }

      #olhada-mobile {
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: var(--orange);
      }
    }
  }

  #solutions {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 1300px;
    gap: 16px;

    .buttons {
      width: 100%;
      max-width: 400px;
      height: 112px;
      background-color: var(--white);
      color: var(--paragraph);

      border: 1.38182px solid #c8d2df;
      border-radius: 2px;
      padding: 0 50px;
      margin: 0 auto;
      text-transform: uppercase;
      cursor: default;

      :hover {
        transition: all 0.3s;
        background-color: var(--orange);
        color: var(--white);
      }
    }
  }

  @media (min-width: 601px) {
    padding-bottom: 100px;

    #description {
      flex-direction: row;
      padding: 100px;

      #desc-one {
        width: 50%;

        span {
          font-size: 16px;
        }

        h1 {
          font-size: 48px;
        }

        #olhada-desktop {
          display: flex;
          margin-top: 50px;
        }
      }

      #desc-two {
        width: 50%;

        #bold-desc-two,
        #paragraph-desc-two,
        span {
          font-size: 16px;
        }

        #olhada-mobile {
          display: none;
        }
      }
    }

    #solutions {
      .buttons {
        font-size: 18px;
        border: 2px solid #C8D2DF;
        
        :hover {
            border: none;
        }
      }
    }
  }
`;